<template>
    <svg
        width="128"
        height="128"
        viewBox="0 0 128 128"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
            d="M74.7911 41.8782C69.6488 37.9934 63.6704 32.4667 61.7635 26.7085C58.4721 16.7633 70.9885 34.5751 83.7698 47.9909C96.7079 61.5745 104.518 54.6782 104.518 54.6782C104.518 54.6782 92.7671 46.64 93.6553 43.4082C94.5434 40.1803 100.518 33.4145 93.7822 27.7124C87.0463 22.0102 80.8217 25.6039 76.8436 31.5412C75.5188 33.519 65.6595 25.5554 61.9314 23.7119"
            class="primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M77.3652 31.3771C77.3652 31.3771 85.1758 41.6805 93.4641 44.4196L93.8821 41.5611C86.2469 38.9414 78.9288 29.4478 78.9288 29.4478L77.3652 31.3771Z"
            class="primary-fill primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M71.8223 41.7625L74.8413 41.9304C78.6738 42.1431 81.7189 45.2255 81.8869 49.0618L82.4093 61.0371"
            class="primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M73.1211 49.3081V93.873"
            class="primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M67.4609 49.5544V94.5224"
            class="primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M61.7949 49.8008V95.1755"
            class="primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M56.1309 50.0469V95.8246"
            class="primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M36.2848 107.897C38.1809 107.897 39.718 106.36 39.718 104.464C39.718 102.568 38.1809 101.031 36.2848 101.031C34.3887 101.031 32.8516 102.568 32.8516 104.464C32.8516 106.36 34.3887 107.897 36.2848 107.897Z"
            class="primary-fill primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M57.1523 21.2974V30.4477"
            class="primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M57.7655 18.5508H47.615C46.6896 18.5508 45.9395 19.301 45.9395 20.2264V20.5361C45.9395 21.4615 46.6896 22.2117 47.615 22.2117H57.7655C58.6908 22.2117 59.441 21.4615 59.441 20.5361V20.2264C59.441 19.301 58.6908 18.5508 57.7655 18.5508Z"
            class="primary-fill primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M43.1914 42.5759C37.631 42.5759 33.123 47.0839 33.123 52.6443V93.9289C33.123 98.5302 36.6458 102.363 41.2322 102.751L45.1356 103.079"
            class="primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M43.1935 42.5759C39.9916 45.4867 38.1817 49.6253 38.2153 53.9541L38.6146 102.064"
            class="primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M46.2226 25.0479C46.2226 25.0479 38.5015 45.7853 60.4033 43.6545C87.0893 41.0572 45.3008 19.7189 45.4053 49.2111C45.5135 79.8117 41.0429 104.408 58.2911 104.087C87.4625 103.546 83.7643 93.8768 83.2082 64.1569"
            class="accent-stroke"
            stroke-width="6.7172"
            stroke-miterlimit="10" />
        <path
            d="M80.0329 108.016C81.929 108.016 83.4661 106.479 83.4661 104.583C83.4661 102.687 81.929 101.15 80.0329 101.15C78.1367 101.15 76.5996 102.687 76.5996 104.583C76.5996 106.479 78.1367 108.016 80.0329 108.016Z"
            class="primary-fill primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M50.0797 109.449C51.9758 109.449 53.513 107.912 53.513 106.016C53.513 104.12 51.9758 102.583 50.0797 102.583C48.1836 102.583 46.6465 104.12 46.6465 106.016C46.6465 107.912 48.1836 109.449 50.0797 109.449Z"
            class="primary-fill primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
    </svg>
</template>
